export default {"src":"/_next/static/media/sr.dc9b4895.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};